export default __webpack_public_path__ + "static/media/bar-chart.fc3ddd7d.svg";